export default __webpack_public_path__ + "dev/viewer.css";